module.exports = __webpack_public_path__ + "img/mc.080525cb.svg";